import { pbx_operators_base_breadcrumbs } from './_module';

const index = pbx_operators_base_breadcrumbs
  .extend('pbx.sip-account.index')
  .add('pbx.breadcrumb.sip-account.index', { name: 'pbx.sip-account.index' });

const create = index
  .extend('pbx.sip-account.create')
  .add('pbx.breadcrumb.sip-account.create', { name: 'pbx.sip-account.create' });

export const pbx_sip_breadcrumbs = [index, create];
